import { render } from "./Settings.vue?vue&type=template&id=0d5c2974"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/user/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d5c2974"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d5c2974', __exports__)) {
    api.reload('0d5c2974', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=0d5c2974", () => {
    api.rerender('0d5c2974', render)
  })

}


export default __exports__